import { Illustration } from "../Illustration.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/illustration/variants/PillsIllustration.tsx
const PillsIllustration = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(Illustration, {
		...props,
		svgFile: "pills.svg",
		alt: t("illustration.imageAlt.pills")
	});
};

//#endregion
export { PillsIllustration };